import platformHelpers from 'Models/uiConfig/platformHelpers';
import { onStoragePermissionsChanged } from 'Utils/browserStorage';

Promise.resolve(platformHelpers.initializePlatformStorage(onStoragePermissionsChanged))
  .then(() => import('./runInitFunc'))
  .then(() => import('./application'));
